import AnalyticsHelper from '../../utils/analytics-helper.js';
import DealerMapper from '../../utils/dealer-mapper';

export default class SelectedPreferredDealer {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.batd-prefered-dealer-result');
        this.myAccount2 = parent.myAccount2;
        this.background = parent.background;
        this.dealerUrl = this.el.dataset.dealerUrl;
        this.dealerFilter = this.el.dataset.dealerFilter;
        this.template = _.template(parent.el.querySelector('#prefered-dealer-result').innerHTML.replaceAll('\\', ''));
    }

    
    async show(){
        if(this.myAccount2?.isLoggedIn()) {
            const details = await window.HONDA.MyAccount2.client.getPersonalDetails();
            const dealerCode = details?.preferredDealercode;
    
            if (this.router.params.has(this.router.data.param) && dealerCode) {
                const filters = [this.dealerFilter, this.router.params.get('filter')].filter((f)=>f).join(',');
                const result = dealerCode ? await window.HONDA.MyAccount2.client.getDealerDetails(this.dealerUrl, dealerCode, filters) : null;
                const dealer = result ? DealerMapper.map(result) : null;
                if(dealer){
                    this.el.innerHTML = this.template({ dealer });

                    this.el.querySelectorAll('li').forEach((item) => {
                        const address = item.querySelector('.dealer-address');
                        const cta = item.querySelector('.cta-button');
        
                        address.addEventListener('click', (e) => this.map(e));
                        cta.addEventListener('click', (e) => this.select(e));
        
                        AnalyticsHelper.template(address, { dealer: cta.dataset.id, model: this.router.params.get(this.router.data.param)});
                        AnalyticsHelper.template(cta, { dealer: cta.dataset.id, model: this.router.params.get(this.router.data.param)});
                    });

                    this.el.classList.remove('hide');
                    this.animate();
                    this.background.hide();
                }
            } else {
                this.el.classList.add('hide');
                this.background.show();
            }
        } else {
            this.el.classList.add('hide');
            this.background.show();
        }
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        this.el.classList.remove('pre-animation');
        this.el.classList.add('apply-animation');
    }

    map(e) {
        e.preventDefault();
        if(this.getViewportWidth() < 800 ){
            e.currentTarget.closest('.flex-wrapper').querySelector('.drop-link').classList.toggle('active');
            e.currentTarget.closest('li').querySelector('.map').classList.toggle('active');
        }
    }

    select(e) {
        e.preventDefault();
        const { id } = e.currentTarget.dataset;
        const { dealername } = e.currentTarget.dataset;
        this.router.params.set('dealer', id);
        this.router.params.set('dealername', dealername);
        this.router.update('form');
    }
    
}
